var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useId, useState } from 'react';
import { cx } from '../../utils/dom';
import * as S from './styles';
import { Typography } from '../Typography';
import { useTheme } from '../../themes';
import { Modifiers } from '../../helpers/getModifiers';
var getOnlyKeysProps = Modifiers.getOnlyKeysProps, allAcceptableProps = Modifiers.allAcceptableProps;
var keys = __spreadArray(__spreadArray([], allAcceptableProps.spacings, true), allAcceptableProps.sizes, true);
export var Textarea = forwardRef(function (props, ref) {
    var _a, _b, _c, _d, _e, _f, _g;
    var idProp = props.id, rest = __rest(props, ["id"]);
    var getContainerProps = getOnlyKeysProps(rest, keys);
    var theme = useTheme();
    var labelTypography = __assign({ color: (_b = (_a = props === null || props === void 0 ? void 0 : props.labelTypographyProps) === null || _a === void 0 ? void 0 : _a.color) !== null && _b !== void 0 ? _b : theme.neutrals.gray8 }, props === null || props === void 0 ? void 0 : props.labelTypographyProps);
    var helperTextTypography = __assign({ color: (props === null || props === void 0 ? void 0 : props.hasError)
            ? theme.brand.color.negative.pure
            : (_d = (_c = props === null || props === void 0 ? void 0 : props.helperTypographyProps) === null || _c === void 0 ? void 0 : _c.color) !== null && _d !== void 0 ? _d : theme.neutrals.gray5 }, props === null || props === void 0 ? void 0 : props.helperTypographyProps);
    var letterCounterTypography = __assign({ color: theme.neutrals.gray5 }, props === null || props === void 0 ? void 0 : props.letterCounterTypography);
    var uuid = useId();
    var id = idProp || "field-".concat(uuid);
    var htmlFor = (_f = (_e = props === null || props === void 0 ? void 0 : props.labelTypographyProps) === null || _e === void 0 ? void 0 : _e.htmlFor) !== null && _f !== void 0 ? _f : id;
    var footerJustifyContent = (props === null || props === void 0 ? void 0 : props.helperText)
        ? 'space-between'
        : 'flex-end';
    var _h = useState(0), letterCounter = _h[0], setLetterCounter = _h[1];
    function onChange(e) {
        var _a;
        if (props === null || props === void 0 ? void 0 : props.maxLength) {
            setLetterCounter(e.currentTarget.value.length);
        }
        (_a = props === null || props === void 0 ? void 0 : props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, e);
    }
    var mustShowFooter = !!(props === null || props === void 0 ? void 0 : props.helperText) || !!(props === null || props === void 0 ? void 0 : props.maxLength);
    return (
    // @ts-ignore
    _jsxs(S.Container, __assign({ "data-testid": "textarea-container" }, getContainerProps, { style: { opacity: (rest === null || rest === void 0 ? void 0 : rest.disabled) ? 0.5 : 1 } }, { children: [!!(props === null || props === void 0 ? void 0 : props.label) && (_jsx(Typography, __assign({ "data-testid": "textarea-label", type: "l3", htmlFor: htmlFor }, labelTypography, { children: props.label }))), _jsx(S.Textarea, __assign({ "data-testid": "textarea", id: id, ref: ref, className: cx(props === null || props === void 0 ? void 0 : props.className), resize: (_g = props === null || props === void 0 ? void 0 : props.resize) !== null && _g !== void 0 ? _g : 'none' }, rest, { onChange: function (e) { return onChange(e); } })), mustShowFooter && (_jsxs(S.Footer, __assign({ "data-testid": "textarea-footer", justifyContent: footerJustifyContent }, { children: [!!(props === null || props === void 0 ? void 0 : props.helperText) && (_jsx(Typography, __assign({ "data-testid": "textarea-helper-text" }, helperTextTypography, { type: "l6" }, { children: props.helperText }))), !!(props === null || props === void 0 ? void 0 : props.maxLength) && (_jsxs(Typography, __assign({ "data-testid": "textarea-letter-counter" }, letterCounterTypography, { type: "l5" }, { children: [letterCounter, "/", props.maxLength] })))] })))] })));
});
